module.exports = __webpack_public_path__ + "img/jingyan.b3a9865e.b3a9865e.jpg";